var scope_0 = require('/zeit/63138a01/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/83642ab9eff317b89b8f109032463f4b.js').default;export default
        Object.assign({}, scope_0 )
    